<template>
    <v-card :width="isDesktop ? 350 : '100%'" class="ma-auto" flat :outlined="isDesktop" tile>
        <v-container fluid class="signup-container py-5">
            <div class="signup-header py-5" ref="header" v-if="!noHeaders">
                <div class="signup-header__logo d-flex justify-center px-6">
                    <router-link to="/" v-ripple>
                        <icon-logo size=150 ref="iconLogo"></icon-logo>
                    </router-link>
                </div>
            </div>
            <div class="signup-body" :style="!noEntryAnim ? 'height: 0; overflow: hidden;' : ''" ref="body">
                <div class="signup-body__content">
                    <div class="px-6 mt-4">
                        <div class="reveal-item">
                            <facebook-button></facebook-button>
                        </div>
                        <div class="reveal-item">
                            <google-button></google-button>
                        </div>
                    </div>
                    <div class="my-8 px-6 reveal-item">
                        <div class="divider grey--text">
                            <span class="divider__text subtitle-2">OR</span>
                        </div>
                    </div>
                    <div class="reveal-item">
                        <form-login @sendData="manageData"></form-login>
                    </div>
                    <div class="my-8 px-6 reveal-item">
                        <v-divider></v-divider>
                    </div>
                    <div class="reveal-item">
                        <p class="py-0 px-6 subtitle-2 text-center">
                            <v-btn text class="text-lowercase body-2 textLinks--text" to="/account/password/reset/">forgot password?</v-btn> <br>
                            Don't have an account? <router-link to="/account/signup/" class="textLinks--text">Sign up</router-link>
                        </p>
                    </div>
                </div>
            </div>
        </v-container>
    </v-card>
</template>
<style scoped>
.signup-container {
    display: flex;
    flex-direction: column;
    min-height: 200px;
}

.signup-header {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    flex-direction: column;

}

.signup-header__logo,
.signup-header__text {
    max-width: 100%;
}
</style>
<script>
/* eslint-disable */
import loginForm from "@/components/forms/form-login.vue"
import formMixins from "@/mixins/mixin-animation-form.js"
import googleButton from "@/components/buttons/google-login-button.vue"
import facebookButton from "@/components/buttons/fb-login-button.vue"
import {
    SIGN_IN_USER
} from "@/store/actions.type.js"

export default {
    props: ['noEntryAnim', 'noHeaders'],
    mixins: [formMixins],
    components: {
        'form-login': loginForm,
        googleButton,
        facebookButton
    },

    mounted() {
        this.$nextTick(() => {
            // Init signup animation
            if (!this.noEntryAnim) this.signupEntry()
        })
    },

    beforeRouteLeave(to, from, next) {
        // Body leave and route change
        if (!this.noEntryAnim) {
            this.bodyLeave(() => {
                // Go to next route
                next()
            })
        } else {
            next()
        }

    },

    methods: {
        // Manage send event from form
        manageData(formData) {
            // Send request
            this.$store.dispatch(SIGN_IN_USER, formData)
        }
    }
}
</script>